import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export interface BankAccountCategorie {
  id: string;
  name: string;
  description: string;
}

const EMPTY_ITEM_NAME = 'NONE';

const getBankAccountCategories = () => api.get(API_URL.ENUMS_ACCOUNT_CATEGORIES);
const BANK_ACCOUNT_CATEGORIES_LIST_QUERY_NAME = 'getBankAccountCategories';
const useBankAccountCategoriesQuery = () => {
  const { data, isLoading } = useQuery([BANK_ACCOUNT_CATEGORIES_LIST_QUERY_NAME], getBankAccountCategories);
  const formatedData = useMemo(
    () =>
      data?.data
        .filter((item) => item.name !== EMPTY_ITEM_NAME)
        .map((item) => ({
          id: `${item.id}`,
          name: item.name || '',
          description: item.description || '',
        })),
    [data]
  );

  return {
    data: formatedData || [],
    isLoading,
  };
};

export default useBankAccountCategoriesQuery;
